import $ from "jquery";
import f from "../funcs";


$.fn.hasChild = function(child) {
    let elem;
    for (let i = 0, n = this.length; i < n; i++) {
        elem = this[i];

        if ( f.checkElemIn(child, elem) ) {
            return true;
        }
    }

    return false;
};

export default $.fn.hasChild;
